import {
  DxChart,
  DxSeries,
  DxCommonSeriesSettings,
  DxLegend,
  DxTooltip,
  DxSeriesTemplate,
} from 'devextreme-vue/chart';
import { mapGetters } from 'vuex';

export default {
  name: 'plan-compost',
  components: {
    DxChart,
    DxSeries,
    DxCommonSeriesSettings,
    DxLegend,
    DxTooltip,
    DxSeriesTemplate,
  },
  props: [],
  data() {
    return {
      planCompostSerie: [],
    };
  },
  computed: {
    ...mapGetters('treatmentStepper', ['treatmentPlan']),
  },
  mounted() {
    this.treatmentPlan.products.forEach((item, index) => {
      const itemValue = this.treatmentPlan.timeValues[index];
      for (const prop in itemValue) {
        this.planCompostSerie.push({
          productName: item.name,
          monthWeek: prop,
          value: itemValue[prop],
        });
      }
    });
  },
  methods: {
    customizeTooltip(point) {
      return {
        html: `<div><div class='tooltip-header'>${
          point.argumentText
        }</div><div class='tooltip-body'>
          <span class='bold'>${this.$t('product')}: ${point.seriesName} </span>
          </div>
          <span class="bold"> ${this.$t('Dose')}: ${point.value} KG-L/HA</span> `,
      };
    },
  },
};
